import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { INLINES, MARKS } from '@contentful/rich-text-types';
import classNames from 'classnames';

export function generateOptions({ useExternalLinks = false, preserveWhitespace } = {}) {
    return {
        renderMark: {
            [MARKS.BOLD]: (text) => (
                <span className='font-bold' key={`${text}-key`}>
                    {text}
                </span>
            ),
        },
        renderNode: {
            [INLINES.HYPERLINK]: (node, children) => (
                <>
                    {useExternalLinks && (
                        <a href={node.data.uri} target='_blank' rel='noreferrer'>
                            {children}
                        </a>
                    )}
                    {!useExternalLinks && <a href={node.data.uri}>{children}</a>}
                </>
            ),
        },
        renderText: (text) => text.split('\n').flatMap((t, i) => [i > 0 && <br />, t]),
        preserveWhitespace,
    };
}

export function ContentfulText({ textPlain, textRichRaw, textHtml, options, className, children }) {
    if (textHtml) {
        return (
            <div
                className={classNames('body break-words', className)}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: textHtml,
                }}
            >
                {children}
            </div>
        );
    }

    if (textRichRaw) {
        return documentToReactComponents(JSON.parse(textRichRaw), generateOptions(options));
    }

    return (
        <span className={classNames('break-words', className)}>
            {textPlain ?? 'Not Found'}
            {children}
        </span>
    );
}
